import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  margin: 0 0 16px;
  background: ${ColorPalette.HEX.White};
  box-shadow: rgba(${ColorPalette.RGB.DeepTaupe2}, 0.2) 0px 6px 10px 0px;
  border-radius: 8px;
  max-width: calc(100vw - 150px);
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const Header = styled.div`
  height: 60px;
  color: ${ColorPalette.HEX.PineTree};
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${({ theme }) => theme.primaryBackgroundColor};
`;

export const Border = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid ${ColorPalette.HEX.Black};
`;

export const StopTable = styled.aside`
  flex: 1;

  & table {
    width: 100%;
    padding: 0;
    border-collapse: collapse;
    border-style: hidden;
    table-layout: fixed;
    border-right: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
  }
  & th,
  & td {
    width: 136px;
    border-bottom: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
    text-align: center;
    vertical-align: middle;
    height: 49px;
    position: relative;
    cursor: pointer;
    &:hover ${Border} {
      display: block;
    }
  }
  & span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: ${ColorPalette.HEX.DimGray2};
  }
  & tr::last-child td {
    border-bottom: none;
  }
`;

export const Airline: any = styled.th`
  width: 136px;
  text-align: center;
`;

Airline.Div = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

Airline.Logo = styled.img`
  width: 16px;
  margin-right: 10px;
`;

Airline.Text = styled.div`
  max-width: 57%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  line-height: 1.2em;
`;

export const AirTable = styled.div`
  overflow: hidden;
  flex: 5;
  & table {
    border-collapse: collapse;
    border-style: hidden;
    table-layout: fixed;
    width: 100%;
  }
  & th,
  & td {
    vertical-align: middle;
    text-align: center;
    height: 49px;
    font-size: 12px;
    color: ${ColorPalette.HEX.DimGray2};
    border-bottom: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
    border-right: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
    position: relative;
    cursor: pointer;
    &:hover ${Border} {
      display: block;
    }
  }
  & tr::last-child td {
    border-bottom: none;
  }
  & td::last-child {
    border-right: none;
  }
`;

export const Price = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${ColorPalette.HEX.Black};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowButton = styled.div`
  position: absolute;
  cursor: pointer;
  top: 50%;
  font-size: 20px;
  padding: 6px;
  border-radius: 50%;
  background: ${ColorPalette.HEX.White};
  height: 32px;
  width: 32px;
  line-height: 1;
  box-shadow: rgba(${ColorPalette.RGB.DeepTaupe2}, 0.2) 0px 6px 10px 0px;
`;

export const PrevButton: any = styled(ArrowButton)`
  left: 0;
  transform: translateY(-50%) translateX(-50%);
  i {
    display: inline-block;
    transform: rotate(180deg);
  }
`;

PrevButton.Icon = styled(BsArrowLeft)``;

export const NextButton: any = styled(ArrowButton)`
  right: 0;
  transform: translateY(-50%) translateX(50%);
`;

NextButton.Icon = styled(BsArrowRight)``;
